export const MOBILE_MAX_WIDTH_LAYOUT = '450px';
export const TRAINER_PROFILE_SEO_META_DESCRIPTION =
  'Find 5-star dog trainers on Rover.com. Book dog training in your home with credentialed and background-checked trainers committed to rewards-based methodologies.';
